import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { GENERAL_CASHBACK_202505_GA_TAGS } from 'src/constants';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import HowToVideo from './assets/how-to-video.mp4';
import VerticalStepperWithLine from './VerticalStepperWithLine';
import styles from './SectionHowTo.module.scss';

export default function SectionHowTo({ id }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (videoRef.current) {
          if (entry.isIntersecting) {
            videoRef.current.play();
          } else {
            videoRef.current.pause();
          }
        }
      },
      { threshold: 0.5 }
    );

    if (videoRef.current) observer.observe(videoRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section id={id || 'how-to-section'}>
      <section className={styles.innerSection}>
        <h1>使い方</h1>
        <h2>簡単4ステップで購入</h2>
        <div className={styles.banners}>
          <div>
            <VerticalStepperWithLine />
            <OutboundLink
              href="/payments"
              target="_blank"
              rel="noreferrer"
              // eslint-disable-next-line security/detect-non-literal-fs-filename
              className={cx(
                // eslint-disable-next-line security/detect-non-literal-fs-filename
                styles.link,
                GENERAL_CASHBACK_202505_GA_TAGS.INTRO_5
              )}
            >
              使い方の詳細を見る
            </OutboundLink>
          </div>
          <video
            ref={videoRef}
            autoPlay
            muted
            width={328}
            height={410}
            loop
            playsInline
          >
            <source src={HowToVideo} type="video/mp4" />
            <track kind="captions" />
          </video>
        </div>
      </section>
    </section>
  );
}
